import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Container = styled(Box)`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  bottom: 20px;
  right: 20px;
`;
